import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContentWrapperComponent } from './content-wrapper/content-wrapper.component';
import { EnadisComponent } from './enadis/enadis.component';
import { EnadisInfoComponent } from './enadis/enadis-info/enadis-info.component';
import { EnadisExploreComponent } from './enadis/enadis-explore/enadis-explore.component';
import { EnadisGraphsComponent } from './enadis/enadis-graphs/enadis-graphs.component';
import { EnadisCompareComponent } from './enadis-compare/enadis-compare.component';
import { EnadisCompareGraphsComponent } from './enadis-compare/enadis-compare-graphs/enadis-compare-graphs.component';
import { PerfilesComponent } from './perfiles/perfiles.component';
import { EndosigComponent } from './endosig/endosig.component';
import { EndosigInfoComponent } from './endosig/endosig-info/endosig-info.component';
import { EndosigExploreComponent } from './endosig/endosig-explore/endosig-explore.component';
import { EndosigGraphsComponent } from './endosig/endosig-graphs/endosig-graphs.component';

const AppRoutes: Routes = [
  {
    path: '',
    redirectTo: '/content/enadis',
    pathMatch: 'full'
  },
  {
    path: 'content',
    component: ContentWrapperComponent,
    children: [
      {
        path: 'perfiles',
        component: PerfilesComponent,
      },
      {
        path: 'compara-enadis',
        component: EnadisCompareComponent,
        children: [
          {
            path: '',
            component: EnadisCompareGraphsComponent,
            pathMatch: 'full'
          },
          {
            path: ':indicator',
            component: EnadisCompareGraphsComponent
          },
        ]
      },
      {
        path: 'enadis',
        component: EnadisComponent,
        children: [
          {
            path: '',
            component: EnadisInfoComponent,
            pathMatch: 'full'
          },
          {
            path: 'explore',
            component: EnadisExploreComponent
          },
          {
            path: 'explore/:idQuestion',
            component: EnadisGraphsComponent
          },
        ]
      },
      {
        path: 'endosig',
        component: EndosigComponent,
        children: [
          {
            path: '',
            component: EndosigInfoComponent,
            pathMatch: 'full'
          },
          {
            path: 'explore',
            component: EndosigExploreComponent
          },
          {
            path: 'explore/:idQuestion',
            component: EndosigGraphsComponent
          },
        ]
      },
      {
        path: '',
        redirectTo: '/content/enadis',
        pathMatch: 'full'
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(AppRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts